(function() {
  // Countdown timer - next Wednesday 12:00 CET
  function getNextWednesday() {
    var now = new Date();
    var target = new Date();
    var day = now.getDay();
    var daysUntil = (3 - day + 7) % 7;
    if (daysUntil === 0) {
      var cetHour = now.getUTCHours() + 1;
      if (cetHour >= 12) daysUntil = 7;
    }
    target.setDate(now.getDate() + daysUntil);
    target.setUTCHours(11, 0, 0, 0);
    return target;
  }

  function updateCountdown() {
    var now = new Date();
    var next = getNextWednesday();
    var rem = next - now;
    var daysEl = document.getElementById('countdown-days');
    var hoursEl = document.getElementById('countdown-hours');
    var minsEl = document.getElementById('countdown-minutes');
    var secsEl = document.getElementById('countdown-seconds');
    if (!daysEl) return;
    if (rem <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minsEl.textContent = '00';
      secsEl.textContent = '00';
      var label = document.querySelector('.drops-countdown__label');
      if (label) { label.textContent = 'DROP IS LIVE!'; label.style.color = '#c8ff00'; }
      return;
    }
    daysEl.textContent = String(Math.floor(rem / 86400000)).padStart(2, '0');
    hoursEl.textContent = String(Math.floor((rem % 86400000) / 3600000)).padStart(2, '0');
    minsEl.textContent = String(Math.floor((rem % 3600000) / 60000)).padStart(2, '0');
    secsEl.textContent = String(Math.floor((rem % 60000) / 1000)).padStart(2, '0');
  }

  // Scroll animations
  function initScrollAnimations() {
    if (typeof anime === 'undefined') return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var cards = entry.target.querySelectorAll('.drops-product-card');
          if (cards.length) {
            anime({ targets: cards, opacity: [0.3, 1], translateY: [20, 0], duration: 500, delay: anime.stagger(80), easing: 'easeOutQuad' });
          }
          var header = entry.target.querySelector('.drops-section-header');
          if (header) {
            anime({ targets: header, opacity: [0, 1], translateY: [15, 0], duration: 600, easing: 'easeOutQuad' });
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.drops-section').forEach(function(s) { observer.observe(s); });
  }

  function init() {
    // Start countdown immediately
    updateCountdown();
    setInterval(updateCountdown, 1000);
    
    // Scroll animations - if anime.js loaded
    if (typeof anime !== 'undefined') {
      initScrollAnimations();
    } else {
      var attempts = 0;
      var check = setInterval(function() {
        attempts++;
        if (typeof anime !== 'undefined') {
          clearInterval(check);
          initScrollAnimations();
        } else if (attempts > 20) {
          clearInterval(check);
        }
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
